import dayjs from 'dayjs'
// Client ID and API key from the Developer Console
// const CLIENT_ID = '355251214520-vgmk9kqskui8122u71ml55j1efqtrpl6.apps.googleusercontent.com'
// const API_KEY = 'AIzaSyC1wblJhe4tVQHeM23aYzKLWGXFeb9764s'
const CLIENT_ID = '281235339148-p2mki3v62lfh5vo6pth3e59l4u06disn.apps.googleusercontent.com'
const API_KEY = 'AIzaSyAeRVeL_MIfBbhrS6jFymrZHzxrh9RDWpg'

// Array of API discovery doc URLs for APIs used by the quickstart
const DISCOVERY_DOCS = ['https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest']
// Authorization scopes required by the API; multiple scopes can be
// included, separated by spaces.
// see https://developers.google.com/identity/protocols/googlescopes#calendarv3
const SCOPES = 'https://www.googleapis.com/auth/calendar.readonly https://www.googleapis.com/auth/calendar.events'

export default class GoogleCalendarService {
  constructor (cbInitialized = null) {
    this.api = window.gapi
    this.initialized = false

    const vm = this

    this.api.load('client:auth2', {
      callback () {
        // Handle gapi.client initialization.
        vm.initClient(cbInitialized)
      },
      onerror () {
        // Handle loading error.
        alert('gapi.client failed to load!')
      },
      timeout: 5000, // 5 seconds.
      ontimeout () {
        // Handle timeout.
        alert('gapi.client could not load in a timely manner!')
      },
    })
  }

  initClient (cbInitialized = null) {
    this.api.client.init({
      apiKey: API_KEY,
      clientId: CLIENT_ID,
      discoveryDocs: DISCOVERY_DOCS,
      scope: SCOPES,
    }).then(() => {
      this.initialized = true
      console.log('Google API Client initialized')
      if (cbInitialized) { cbInitialized() }
    })
  }

  signIn () {
    return this.api.auth2.getAuthInstance().signIn()
  }

  signOut () {
    return this.api.auth2.getAuthInstance().signOut()
  }

  isSignedIn () {
    return this.initialized && this.api.auth2.getAuthInstance().isSignedIn.get()
  }

  // Add a new event to a calendar
  // see https://developers.google.com/calendar/v3/reference/events/insert
  insertEvent (calendarId, startDate, endDate, owner, summary, description = '', location = '', attendees = []) {
    const resource = {
      summary,
      location,
      description,

      'start': {
        'dateTime': startDate.toISOString(),
        'timeZone': 'Europe/Berlin'
      },
      'end': {
        'dateTime': endDate.toISOString(),
        'timeZone': 'Europe/Berlin'
      },
      organizer: {
        displayName: owner
      },
      source: {
        title: owner,
        url: window.location.href
      },
      extendedProperties: {
        shared: {
          owner
        }
      },
      attendees,

    }
    return new Promise((resolve, reject) => {
      this.api.client.calendar.events.insert({ calendarId, resource })
        .then((response) => {
          resolve(response.result)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  // Remove event from a calendar
  // see https://developers.google.com/calendar/v3/reference/events/insert
  deleteEvent (calendarId, eventId) {
    return new Promise((resolve, reject) => {
      this.api.client.calendar.events.delete({ calendarId, eventId })
        .then((response) => {
          resolve(response.result)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  getResourceCalendars () {
    return new Promise((resolve, reject) => {
      this.api.client.calendar.calendarList.list()
        .then((response) => {
          const resourceCalendarItems = response.result.items.filter(item => item.id.indexOf('@resource') !== -1)
          resolve(resourceCalendarItems)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  // get events of a day
  // https://developers.google.com/calendar/v3/reference/events/list
  // An event has the following structure: https://developers.google.com/calendar/v3/reference/events#resource
  getEventsByCalendarIdOfDay (calendarId, date) {
    var start = new Date(date)
    start.setHours(0, 0, 0, 0)

    var end = new Date(date)
    end.setHours(23, 59, 59, 999)

    return new Promise((resolve, reject) => {
      this.api.client.calendar.events.list({
        calendarId,
        alwaysIncludeEmail: true,
        timeMin: start.toISOString(),
        timeMax: end.toISOString(),
        showDeleted: false,
        singleEvents: true,
        orderBy: 'startTime',
      }).then((response) => {
        resolve(response.result.items)
      }).catch((error) => {
        reject(error)
      })
    })
  }

  getRoomState (events, ofDateTime) {
    if (Array.isArray(events) && ofDateTime) {
      for (let i = 0; i < events.length; i++) {
        const now = dayjs(ofDateTime)
        const currentEventStartDate = dayjs(events[i].start.dateTime)
        const currentEventEndDate = dayjs(events[i].end.dateTime)
        const nextEventStartDate = i < events.length - 1 ? dayjs(events[i + 1].start.dateTime) : null

        if (now.isAfter(currentEventStartDate) && now.isBefore(currentEventEndDate)) {
          const leftDuration = dayjs(currentEventEndDate.valueOf() - now.valueOf() - 3600000)
          return { isOccupied: true, leftDuration, event: events[i] }
        } else {
          if (now.isBefore(currentEventStartDate)) {
            const leftDuration = dayjs(currentEventStartDate.valueOf() - now.valueOf() - 3600000)
            return { isOccupied: false, leftDuration }
          } else if (nextEventStartDate) {
            if (now.isBefore(nextEventStartDate)) {
              const leftDuration = dayjs(nextEventStartDate.valueOf() - now.valueOf() - 3600000)
              return { isOccupied: false, leftDuration }
            }
          }
        }
      }
    }
    // there is no event any more
    return { isOccupied: false, leftDuration: dayjs().endOf('day').subtract(dayjs()) }
  }
}
